import React from 'react';
import { PropTypes } from 'prop-types';
import CustomSelect from './CustomSelect';

export default {
  title: 'Components/Inputs/CustomSelect',
  component: CustomSelect,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

const CustomSelectComponent = ({
  options, label, setValue, isRequired = false, asteriskWidth = 'w-2',
}) => {
  return (
    <CustomSelect
      options={options}
      label={label}
      setValue={setValue}
      isRequired={isRequired}
      asteriskWidth={asteriskWidth}
    />
  );
};

// Binding the base template
const Template = CustomSelectComponent.bind({});

export const Default = Template.bind({});
Default.args = {
  label: 'Default Select Component',
  options: [{ value: 'Option A', label: 'Option A' }, { value: 'Option B', label: 'Option B' }, { value: 'Option C', label: 'Option C' }],
  setValue: () => {},
};

export const Required = Template.bind({});
Required.args = {
  label: 'Required',
  options: [{ value: 'Option A', label: 'Option A' }, { value: 'Option B', label: 'Option B' }, { value: 'Option C', label: 'Option C' }],
  setValue: () => {},
  isRequired: true,
};

CustomSelectComponent.propTypes = {
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  asteriskWidth: PropTypes.string,
};
